import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Chip } from '../models/chip';

@Component({
  selector: 'chip',
  templateUrl: './chip.template.html',
  styleUrls: ['./chip.style.scss']
})
export class ChipComponent implements OnInit {
  @Input() model: Chip;
  @Input() isAnalytics: boolean;
  @Output() remove = new EventEmitter();
  @Output() edit = new EventEmitter();
  defaultIcon = 'images/equal.svg';
  showMenuItem: boolean;
  isSingleClick: boolean;
  operatorItems = [
    {
      icon: 'images/equal.svg',
      value: '='
    },
    {
      icon: 'images/not-equal-variant.svg',
      value: '!='
    }
  ];
  ngOnInit(): void {
    if (this.isAnalytics) {
      this.operatorItems = this.operatorItems.concat([
        {
          icon: 'images/tilde.svg',
          value: '~'
        },
        {
          icon: 'images/tilde-off.svg',
          value: '!~'
        }
      ]);
    }
    this.setDefaultIcon();
  }
  get operator() {
    return this.model.operatorSymbol;
  }

  get keyword() {
    return this.model.keyword;
  }

  setDefaultIcon(): void {
    if (this.model.operator) {
      this.defaultIcon = this.operatorItems.find(op => op.value === this.model.operator).icon;
    }
  }
  get operands() {
    return this.model.operandsExpression;
  }

  get editable() {
    return !this.readonly && false;
  }

  get readonly() {
    return this.model.readonly;
  }

  changeOperator(): void {
    if (!this.readonly) {
      this.isSingleClick = true;
      setTimeout(() => {
        if (this.isSingleClick) this.showMenuItem = true;
      }, 250);
    }
  }

  toggleOperator(icon: string): void {
    if (!this.readonly) {
      this.isSingleClick = false;
      this.showMenuItem = false;
      const operator = this.operatorItems.find(op => op.icon === icon).value;
      let op = '';
      switch (operator) {
        case '=': {
          this.defaultIcon = 'images/not-equal-variant.svg';
          op = '!=';
          break;
        }
        case '!=': {
          this.defaultIcon = 'images/equal.svg';
          op = '=';
          break;
        }
        case '~': {
          this.defaultIcon = 'images/tilde-off.svg';
          op = '!~';
          break;
        }
        case '!~': {
          this.defaultIcon = 'images/tilde.svg';
          op = '~';
          break;
        }
      }
      this.model.changeOperator(op);
      this.edit.emit();
    }
  }

  selectIcon(item: { icon: string; value: string }): void {
    if (!this.readonly) {
      this.defaultIcon = item.icon;
      this.model.changeOperator(item.value);
      this.edit.emit();
      this.showMenuItem = false;
    }
  }
  close() {
    this.remove.emit(this.model);
  }
}
